import { createElement } from 'react';
import { closeIcon } from '../../utils/icons';

const Modal = ({ content = {}, title = {}, setModal }) => {
    return (
        <div className="bpsmb_modal_main_area" onClick={(e) => {
            if (e.target.classList.contains('bpsmb_modal_main_area')) {
                setModal(false);
            }
        }}>
            <div className="modal_area">
                {/* Close Icon */}
                <div
                    className="closeIcon"
                    onClick={() => setModal(false)}
                    role="button"
                    aria-label="Close Modal"
                    tabIndex={0}
                >
                    {closeIcon}
                </div>

                {/* Title */}
                {title?.tag &&
                    createElement(title?.tag, { className: 'title' }, content?.title)}

                {/* Description */}
                {content?.desc && (
                    <p className="desc" dangerouslySetInnerHTML={{ __html: content.desc }}></p>
                )}
            </div>
        </div>
    );
};

export default Modal;
